const crud = { c: false, r: false, u: false, d: false };

export const models = Object.freeze({
  model: { ...crud },
  concept: { ...crud },
  properties: { ...crud },
});
